import React from "react";
import { Flex, LoadingIndicator, Text, Button } from "@jsq/ds/core";
import { Colors, Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

interface DataValidationPlaceholderProps {
  /** Optional custom message to display */
  message?: string;
  /** Whether to show the loading indicator */
  showLoader?: boolean;
  /** Optional callback to refresh/refetch data */
  onRefresh?: () => void;
  /** Whether the refresh action is in progress */
  isRefreshing?: boolean;
  /** Whether this is an error state */
  isError?: boolean;
}

const DataValidationPlaceholder: React.FC<DataValidationPlaceholderProps> = ({
  message = "We are validating your data files. This would usually take about 2-5 minutes, depending on the size of your data. You may navigate to the dashboard and check in after a few minutes",
  showLoader = true,
  onRefresh,
  isRefreshing = false,
  isError = false,
}) => {
  return (
    <Flex flexDirection="column" gap={Sizes.LG} className={styles.container}>
      <Flex flexDirection="column" gap={Sizes.LG} className={styles.contentContainer}>
        <Text variant="h4" color={Colors.Neutral900}>
          Data Validation
        </Text>

        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={Sizes.LG}
          className={styles.placeholderContent}
        >
          {showLoader && <LoadingIndicator size="large" />}

          <Text
            variant="regular-md"
            color={isError ? Colors.Danger600 : Colors.Neutral600}
            className={styles.messageText}
          >
            {message}
          </Text>

          {onRefresh && (
            <Button
              variant="neutral"
              onClick={onRefresh}
              disabled={isRefreshing}
              className={styles.refreshButton}
            >
              {isRefreshing ? "Refreshing..." : "Refresh Status"}
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DataValidationPlaceholder;
